import { filter, map } from "rxjs/operators";
import { selectSelectedOutskirtBuildingId } from "../../../../selectors/selectOutskirtBuildingInfo";
import { TypeActionBuildings } from "../../../player-base/buildings/actionBuildings";
import { actionOutskirtBuildingDeselect } from "../actionOutskirtsInfo";
export var epicOutskirtBuildingDeselect = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionBuildings.Select ||
            (action.type === TypeActionBuildings.Deselect &&
                selectSelectedOutskirtBuildingId(state$.value) != undefined);
    }), map(actionOutskirtBuildingDeselect));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/epics/epicOutskirtBuildingDeselect.ts
// module id = 1919
// module chunks = 3